// https://stackoverflow.com/a/20732091
export const formatFileSize = (size: number) => {
  const i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
  const num = Number((size / Math.pow(1024, i)).toFixed(2)) * 1;
  return num.toString() + ['b', 'kb', 'mb', 'gb', 'tb'][i];
};
